// アイテム説明表示画面
import React from 'react';
import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { Button, Container } from '@material-ui/core';

const MultiContentDiv = styled.div`
  width: inherit;
  white-space: break-spaces;
  overflow-wrap: anywhere;
  hyphens: auto;
`
type MultiAttributeContentProps = {
  value: string;
}
const MultiAttributeContent: React.FC<MultiAttributeContentProps> = ({value}) => {
  const cursors: number[] = [];
  const firstIx = value.indexOf('---\n');
  if (firstIx === 0) cursors.push(firstIx);
  for (let i = 0; i < value.length;) {
    const ix = value.indexOf('\n---\n', i);
    if (ix === -1) break;
    const targetIx = ix + 1;
    cursors.push(targetIx);
    i = targetIx + 3;
  }

  const contents: string[] = [];
  cursors.forEach((cursor, ix) => {
    if (ix === 0 && cursor !== 0) contents.push(value.substring(0, cursor));
    const divider = value.substring(cursor, cursor + 4);
    const nextCursor = typeof cursors[ix + 1] === 'number' ? cursors[ix + 1] : value.length;
    const content = value.substring(cursor + 4, nextCursor);
    contents.push(divider, content);
  })

  return (
    <>
      { contents.length >= 1 && contents.map(content => {
        if (content === '---\n') return ( <hr style={{width: 'inherit', height: '1px', border: 'none', backgroundColor: '#000000'}} /> );
        else return ( <MultiContentDiv>{content}</MultiContentDiv> );
      }) }
      { contents.length === 0 && <MultiContentDiv>{value}</MultiContentDiv> }
    </>
  );
}

type ItemDescriptionDialogProps = {
  open: boolean;
  onClose: () => void;
  content: string | undefined;
}
const ItemDescriptionDialog: React.FC<ItemDescriptionDialogProps> = ({open, onClose, content}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="md">
      <DialogContent style={{overflowX: 'hidden'}}>
        <Container>
          { content ?       
            <MultiAttributeContent value={content} /> : ''}
        </Container>
      </DialogContent>
      <DialogActions>
        <Button variant="text" color="primary" onClick={onClose}>
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
}
export default ItemDescriptionDialog;
